import { A01, A01Output } from 'api/U011';

export interface Message {
  messageNo: number;
  message: string;
  file: string | null;
  file_name: string | null;
  isUser: boolean;
  revision: number;
  ins_dtm: Date;
}

export interface MessageResponse {
  audition_title: string;
  messages: Message[];
}

export const fetchMessages = async (userId: string, auditionId: string, lang: string) => {
  if (!userId || !auditionId) {
    return;
  }
  try {
    const json = (await A01(userId, auditionId, lang)) as A01Output;
    const messages = json.messages.map((obj) => {
      return {
        messageNo: obj.message_no,
        message: obj.message,
        isUser: obj.is_user,
        file: obj.file1,
        file_name: obj.file_name,
        revision: obj.revision,
        ins_dtm: new Date(obj.ins_dtm),
      } as Message;
    });

    return {
      audition_title: json.audition_title,
      messages: messages,
    } as MessageResponse;
  } catch (err: unknown) {
    console.error(err);
    throw err;
  }
};
